import { render, staticRenderFns } from "./app_device_types.vue?vue&type=template&id=0f053626&scoped=true&"
import script from "./app_device_types.vue?vue&type=script&lang=js&"
export * from "./app_device_types.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f053626",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/brisk/brisk-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0f053626')) {
      api.createRecord('0f053626', component.options)
    } else {
      api.reload('0f053626', component.options)
    }
    module.hot.accept("./app_device_types.vue?vue&type=template&id=0f053626&scoped=true&", function () {
      api.rerender('0f053626', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/fields/dropdown/app_device_types.vue"
export default component.exports